export default __webpack_public_path__ + "static/media/Yenepoya Photos-4.6358b37e.png";